import { useEffect, useState, useContext } from "react";
import restService from "../../../restService";
import CampaignContext from "../../../contexts/CampaignContext";
import { Link } from "react-router-dom";
import Pagination from "../../components/Pagination";
import { PulseLoader } from "react-spinners";

const Agent = ({ campaignId }) => {
  const [agents, setAgents] = useState([]);
  const [loading, setloading] = useState(true);
  const [campaign] = useContext(CampaignContext);
  const [searchTerm, setSearchTerm] = useState("");

  const [page, setPage] = useState(1);
  const [pageNumberLimit, setPageNumberLimit] = useState(3);
  const [itemsPerPage, setItermsPerPage] = useState(10);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(3);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);
  const [actionMenu, setActionMenu] = useState("");
  const indexOfLastPage = page * itemsPerPage;
  const indexOfFirstPage = indexOfLastPage - itemsPerPage;

  useEffect(() => {
    fetchAgents();
  }, [campaign]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const fetchAgents = async () => {
    setloading(true);

    try {
      const {
        data: { data },
      } = await restService.Management.getAgents(campaign.id);
      setloading(false);

      setAgents(data);
    } catch (error) {
      console.log(error);
    } finally {
      setloading(false);
    }
  };

  const showActionMenu = (index) => {
    document.getElementById(`agent-${index}`).classList.toggle("hidden");
    setActionMenu(index);
  };

  const handleDeleteAgent = async (id) => {
    try {
      await restService.Management.deleteAgent(campaign.id, id);

      fetchAgents();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="h-full">
      <div className="md:grid md:grid-cols-3 gap-12 my-4 mb-12">
        <div className="border rounded-lg my-4 bg-white py-5 px-6">
          <div>
            <p className="text-[#848484] text-xs py-1">
              Total Number of Agents
            </p>
            <p className="text-xl">{agents?.length}</p>
          </div>
        </div>
        <div className="border rounded-lg my-4 bg-white py-5 px-6">
          <div>
            <p className="text-[#848484] text-xs py-1">Active Agents</p>
            <p className="text-xl">{agents?.length}</p>
          </div>
        </div>
        <div className="border rounded-lg my-4 bg-white py-5 px-6">
          <div>
            <p className="text-[#848484] text-xs py-1">Inactive Agents</p>
            <p className="text-xl">0</p>
          </div>
        </div>
      </div>

      <div className="my-4 mt-8 ">
        <div className="flex md:flex-row flex-col gap-2 md:items-center justify-between">
          <div className="">
            <label className="relative block">
              <span className="sr-only">Search</span>
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.21879 9.21873L6.64941 6.64935"
                    stroke="#848484"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                  <path
                    d="M4.21875 7.65625C6.11723 7.65625 7.65625 6.11723 7.65625 4.21875C7.65625 2.32027 6.11723 0.78125 4.21875 0.78125C2.32027 0.78125 0.78125 2.32027 0.78125 4.21875C0.78125 6.11723 2.32027 7.65625 4.21875 7.65625Z"
                    stroke="#848484"
                    strokeMiterlimit="10"
                    strokeMiterlimit="square"
                  />
                </svg>
              </span>
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => {
                  // setPage(0);
                  handleSearch(e);
                }}
                className="py-1.5 md:w-auto w-full pl-8 border-none focus:border-none focus:pr-10 focus:outline-none rounded-md bg-[#F4F4F4] "
              />
            </label>
          </div>

          {/* <div className="mx-6">
            <button
              className="flex items-center border hover:bg-[#F4F4F4] border-gray-400	rounded py-1.5 px-3"
              type="button"
            >
              <svg
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.25 1.875H0.625"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
                <path
                  d="M9.37533 1.875H4.79199"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
                <path
                  d="M3.54199 3.125C4.23235 3.125 4.79199 2.56536 4.79199 1.875C4.79199 1.18464 4.23235 0.625 3.54199 0.625C2.85164 0.625 2.29199 1.18464 2.29199 1.875C2.29199 2.56536 2.85164 3.125 3.54199 3.125Z"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
                <path
                  d="M9.375 5H8.75"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
                <path
                  d="M5.20833 5H0.625"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
                <path
                  d="M6.45801 6.25C7.14836 6.25 7.70801 5.69036 7.70801 5C7.70801 4.30964 7.14836 3.75 6.45801 3.75C5.76765 3.75 5.20801 4.30964 5.20801 5C5.20801 5.69036 5.76765 6.25 6.45801 6.25Z"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
                <path
                  d="M1.25 8.125H0.625"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
                <path
                  d="M9.37533 8.125H4.79199"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
                <path
                  d="M3.54199 9.375C4.23235 9.375 4.79199 8.81536 4.79199 8.125C4.79199 7.43464 4.23235 6.875 3.54199 6.875C2.85164 6.875 2.29199 7.43464 2.29199 8.125C2.29199 8.81536 2.85164 9.375 3.54199 9.375Z"
                  stroke="#24211D"
                  strokeMiterlimit="10"
                  strokeLinecap="square"
                />
              </svg>
              <span className="text-sm px-1">Filter</span>
            </button>
          </div> */}
          <div className="flex">
            <Link
              to="/management/add-agent"
              className="flex items-center bg-[#3989DD] border text-white rounded-md py-1 px-3
                         hover:border-[#3989DD] hover:bg-[#4891db] "
              type="button"
            >
              + <span className="mx-3 text-sm">Add New Agent</span>
            </Link>
          </div>
        </div>
      </div>

      <div className="w-full">
        <div className=" align-middle bg-white inline-block w-full">
          <div className="w-full overflow-x-auto">
            <table className="w-full bg-white border-b-lg shadow-sm ">
              <thead className="bg-[#F4F4F4] rounded  py-2">
                <tr>
                  <th className="text-left whitespace-nowrap px-4 py-5 text-sm text-[#24211D] font-normal rounded-l-lg">
                    Phone Number
                  </th>
                  <th className="text-left px-4 whitespace-nowrap text-sm text-[#24211D] py-5 font-normal">
                    Full name
                  </th>
                  <th className="text-left whitespace-nowrap px-4 text-sm text-[#24211D] py-5 font-normal ">
                    Station ID
                  </th>
                  {/* <th className="text-left px-4 text-sm text-[#24211D] py-5 font-normal ">
                  Status
                </th> */}
                  <th className="text-left whitespace-nowrap px-4 text-sm text-[#24211D] py-5 font-normal  rounded-r-lg">
                    {" "}
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody className="text-[#848484]">
                {loading && (
                  <tr className="w-full">
                    <td className="text-center" colSpan="5">
                      <div className="my-8 mx-auto">
                        <PulseLoader color="#FF6A3A" />
                      </div>
                    </td>
                  </tr>
                )}
                {agents?.length === 0 && (
                  <tr className="w-full">
                    <td className="text-center" colSpan="5">
                      <div className="my-8 mx-auto">
                        <img
                          src={require("../../../assets/images/noData.svg")}
                          alt=""
                          className="mx-auto"
                        />
                      </div>
                    </td>
                  </tr>
                )}

                {agents?.length > 0 &&
                  agents
                    ?.filter((item) => {
                      if (searchTerm && isNaN(Number(searchTerm))) {
                        return item?.name?.toLowerCase()?.includes(searchTerm);
                      } else if (searchTerm && !isNaN(Number(searchTerm))) {
                        return (
                          item?.msisdn?.includes(searchTerm) ||
                          (item?.stationId?.toString()?.includes(searchTerm) &&
                            item?.stationId)
                        );
                      } else {
                        return item;
                      }
                    })

                    ?.map((value, index, array) => (
                      <tr className="hover:bg-[#F4F4F4] hover:cursor-pointer focus:bg-[#F4F4F4] focus:cursor-pointer ">
                        <td className="px-4 whitespace-nowrap text-sm text-[#848484] py-4 pl-4">
                          {value?.msisdn}
                        </td>
                        <td className="px-4 whitespace-nowrap text-sm text-[#848484] py-4 pl-4">
                          {value?.name}
                        </td>

                        <td className="px-4 whitespace-nowrap text-sm text-[#848484] py-6 px-auto">
                          {value?.stationId}
                        </td>
                        {/* <td className="px-4 whitespace-nowrap py-6 pl-4">
                        <button className="bg-green-600 text-white m-1 text-sm px-4 py-1.5 rounded-lg hover:bg-white hover:text-green-600 hover:bg-green-100 hover:border-green-600">
                          Redeemed
                        </button>
                      </td> */}
                        <td className="px-4 whitespace-nowrap py-4 pl-4">
                          <div className="relative inline-block">
                            <button
                              className="bg-[#F4F4F4] hover:bg-white py-2 rounded-lg px-2"
                              data-index={index}
                              id="menu-button"
                              aria-expanded="true"
                              aria-haspopup="true"
                              onClick={() => showActionMenu(index)}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2.5 11.875C3.53553 11.875 4.375 11.0355 4.375 10C4.375 8.96447 3.53553 8.125 2.5 8.125C1.46447 8.125 0.625 8.96447 0.625 10C0.625 11.0355 1.46447 11.875 2.5 11.875Z"
                                  fill="#848484"
                                />
                                <path
                                  d="M10 11.875C11.0355 11.875 11.875 11.0355 11.875 10C11.875 8.96447 11.0355 8.125 10 8.125C8.96447 8.125 8.125 8.96447 8.125 10C8.125 11.0355 8.96447 11.875 10 11.875Z"
                                  fill="#848484"
                                />
                                <path
                                  d="M17.5 11.875C18.5355 11.875 19.375 11.0355 19.375 10C19.375 8.96447 18.5355 8.125 17.5 8.125C16.4645 8.125 15.625 8.96447 15.625 10C15.625 11.0355 16.4645 11.875 17.5 11.875Z"
                                  fill="#848484"
                                />
                              </svg>
                            </button>
                            <div
                              id={`agent-${index}`}
                              className={`absolute ${
                                actionMenu !== index && "hidden"
                              } origin-top-right  mt-2 ring-1 ring-black ring-opacity-5 focus:outline-none right-0 z-10 shadow-lg w-50 bg-white rounded-lg`}
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="my-2 flex flex-col gap-3 px-2 w-56">
                                <Link
                                  to={`/management/edit-agent/${value?.msisdn}`}
                                  className=" flex align-center text-blue-700 text-sm hover:bg-[#F4F4F4] hover:rounded-lg px-4 py-1 w-full"
                                >
                                  <span className="mr-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-6 w-6"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="blue"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                      />
                                    </svg>
                                  </span>{" "}
                                  Edit
                                </Link>
                                <button
                                  onClick={() => {
                                    handleDeleteAgent(value?.msisdn);
                                  }}
                                  className="text-red flex align-center text-red-700 text-sm hover:bg-[#F4F4F4] hover:rounded-lg px-4 py-1 w-full"
                                >
                                  <span className="mr-2">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="h-6 w-6"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="red"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      />
                                    </svg>
                                  </span>{" "}
                                  Delete
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                    ?.slice(indexOfFirstPage, indexOfLastPage)}
              </tbody>
            </table>
          </div>

          <Pagination
            page={page}
            setPage={setPage}
            pageNumberLimit={pageNumberLimit}
            maxPageNumberLimit={maxPageNumberLimit}
            setMaxPageNumberLimit={setMaxPageNumberLimit}
            minPageNumberLimit={minPageNumberLimit}
            setMinPageNumberLimit={setMinPageNumberLimit}
            data={agents}
            itemsPerPage={itemsPerPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Agent;
